import { LinearProgress, Theme, Typography } from "@material-ui/core";
import { createStyles, withStyles } from "@material-ui/styles";
import React from "react";

const BorderLinearProgress = withStyles((theme: Theme) => createStyles({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: { backgroundColor: theme.palette.secondary.dark },
  bar: {
    borderRadius: 5,
    backgroundColor: theme.palette.secondary.light,
  },
}))(LinearProgress);

export const CommonLinearProgress = ({
  label,
  value,
}: any) =>
  <>
    <Typography
      variant="h2"
      color="textSecondary"
      className="common-linear-progress"
    >
      {label} {value}%
    </Typography>

    <BorderLinearProgress
      value={value}
      variant="determinate"
    />
  </>
